module.exports = __webpack_public_path__ + "assets/img/d2.e67e0113.jpg";